/**
 * 登出弹出层
 */

import React, { Component } from 'react';
import ReactDOM, { render} from 'react-dom';
import lang from '../../lang/index';
import VideoLayer from '../../living/videolayer';
import Url from 'c-url';

class VideoPop  extends Component {
    static defaultProps = {
       data: {}
    }

    constructor(props){
        super(props);

        this.state = {
            style: {
                left: UP.Global.siteLanguage == 'ar-EG' ? (document.documentElement.offsetWidth - 320 - 10) + 'px' : '10px',
                top: (document.documentElement.offsetHeight - 540 - 10) + 'px'
            }
        }

        this.elementOffset = {
            x: 0,
            y: 0
        }
    }

    onCancel=(e)=> {
        UP.Global.videoInfo = null;
        
        this.props.onHide();
    }

    onMouseDown(e) {
        let el = this.refs.container;
        const offset = this.getDocumentRelativeElementOffset(el);
        
        if ($(e.target).parents('.vcp-controls-panel').length > 0) {
            this.draging =  false;
            return;
        }
        this.draging =  true;
        this.dragStartTime =  +new Date();
        
        window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();

        this.elementOffset = {
            x : e.clientX, 
            y : e.clientY,
            minLeft: 0,
            minTop: 0,
            maxLeft: offset.width - offset.elwidth,
            maxTop: offset.height - offset.elheight
        };
        
        this.setState({
            style: {
                left: offset.x,
                top: offset.y
            }
        });
    }

    onMouseMove(e) {
        window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();

        if (this.draging) {

            const { x, y } = this.getOffsetPosition({ x: e.clientX, y: e.clientY});

            this.elementOffset.x = e.clientX;
            this.elementOffset.y = e.clientY;

            this.setState({
                style: {
                    left: x,
                    top: y
                }
            });
        }
    }

    getOffsetPosition(position, holdInPanel){
        const {x, y , minLeft, maxLeft, minTop, maxTop } = this.elementOffset;
        const style = this.state.style;

        let left = style.left + (position.x - x);
        let top = style.top + (position.y - y);

        if (holdInPanel) {
            if (left < minLeft) {
                left = minLeft;
            } else if (left > maxLeft) {
                left = maxLeft;
            }

            if (top < minTop) {
                top = minTop;
            } else if (top > maxTop) {
                top = maxTop;
            }   
        }

        return {
            x: left,
            y: top
        }       
    }

    onMouseUp(e) {
        if (this.draging) {
            this.draging = false;
            this.dragHoldTime = (+new Date()) - this.dragStartTime;

            const { x, y } = this.getOffsetPosition({ x: e.clientX, y: e.clientY}, true);

            this.setState({
                style: {
                    left: x,
                    top: y
                }
            });
        }
    }


    getDocumentRelativeElementOffset(el) {
        // const parentEl = this.getRelativeParentOfEl(el);
        
        // const {
        //     left: docLeft,
        //     top: docTop,
        //     width: width,
        //     height: height
        // } = parentEl.getBoundingClientRect();

        const {
            left: elLeft,
            top: elTop,
            width: elwidth,
            height: elheight
        } = el.getBoundingClientRect();

        return {
            x: elLeft,
            y: elTop,
            width: document.documentElement.clientWidth,
            height: document.documentElement.clientHeight,
            elwidth: elwidth,
            elheight: elheight
        };
    }

    getRelativeParentOfEl(el) {
        if (el.parentElement) {
            if ($(el.parentElement).css('position') == 'static' && el.tagName !== 'HTML') {
                return this.getRelativeParentOfEl(el.parentElement);
            } else {
                return el.parentElement;
            }
        } else {
            return el;
        }
    }

    render() {
        let data = this.props.data;

        return (
            <div 
                ref="container"
                className="video-pop-wrap"
                style={this.state.style} 
                onMouseDown={this.onMouseDown.bind(this)}
                onMouseMove={this.onMouseMove.bind(this)}
                onMouseUp={this.onMouseUp.bind(this)}
                onMouseLeave={this.onMouseUp.bind(this)}
            >
                <div className="video-pop-close" onClick={this.onCancel}></div>
                <div className="video-pop">
                    <div className="video-screen">
                        <VideoLayer  ref="videolayer" videoid="videolayer" key={data.roomid}  hostid={data.hostid} roomid={data.roomid} avatar={data.avatar}/>
                    </div>
                </div>
            </div>
        );
    }
}


module.exports = {
    create: function (cfg) {
        cfg = cfg || {};
        
        if (this.layer) {
            if (cfg.data && this.roomid == cfg.data.roomid) {
                return;
            }
            this.destroy();
        }

        this.roomid = cfg.data.roomid;

        var mountNode = this.createMountNode();

        

        this.layer = ReactDOM.render(
            <VideoPop {...cfg} onHide={this.onHide.bind(this)}/>,
            mountNode
        );
    },
    onHide: function() {
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },

    destroy: function () {
        if (!this.layer) {
            return;
        }
        ReactDOM.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};


// WEBPACK FOOTER //
// ./js/component/video-pop/index.js